import { render, staticRenderFns } from "./ButtonBlockInListReward.vue?vue&type=template&id=75ac97e6&scoped=true&"
import script from "./ButtonBlockInListReward.vue?vue&type=script&lang=js&"
export * from "./ButtonBlockInListReward.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=75ac97e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ac97e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75ac97e6')) {
      api.createRecord('75ac97e6', component.options)
    } else {
      api.reload('75ac97e6', component.options)
    }
    module.hot.accept("./ButtonBlockInListReward.vue?vue&type=template&id=75ac97e6&scoped=true&", function () {
      api.rerender('75ac97e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/ButtonBlockInListReward.vue"
export default component.exports